module.exports = __webpack_public_path__ + "static/img/ct_qt_3.1ab2e424.png";